import { useEffect, useRef } from 'react';
import type { SessionPhase } from '../types/typing';
import { postSession } from '../api/sessions';
import type { SessionResult } from '@codedrill/shared';

export function useSessionResult(
  phase: SessionPhase,
  snippetId: string | null,
  wpm: number,
  cpm: number,
  accuracy: number,
  errorCount: number,
  elapsedMs: number,
) {
  const submittedRef = useRef(false);

  useEffect(() => {
    if (phase !== 'complete' || !snippetId || submittedRef.current) return;
    submittedRef.current = true;

    const result: SessionResult = {
      snippetId,
      wpm,
      cpm,
      accuracy,
      errorCount,
      durationMs: Math.round(elapsedMs),
      completedAt: new Date().toISOString(),
    };

    postSession(result).catch(() => {
      // Fire-and-forget — result persistence is non-critical to UX
    });
  }, [phase, snippetId, wpm, cpm, accuracy, errorCount, elapsedMs]);

  // Reset submitted flag when phase resets to idle
  useEffect(() => {
    if (phase === 'idle') submittedRef.current = false;
  }, [phase]);
}
